import React, { useState, useEffect } from 'react'
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { SidebarData } from '../../shared/common-utilities/utils/SidebarData';
import { updateSelectedSums } from '../../shared/ReduxStore/Reducers/updateHeaderReducer';
import { Button, Card, CardContent, Stack, Typography, Grid, CardHeader, IconButton } from '@mui/material';
import { ListBox } from '@progress/kendo-react-listbox';
import { TileLayout } from "@progress/kendo-react-layout";
import Movements from '../views/pages/Movements/Movements';
import PartialTrip from '../views/pages/PartialTrip/PartialTrip';
import Agenda from '../views/common/Agenda/Agenda';
import TripRoutes from '../views/pages/TripRoutes/TripRoutes';
import ShipmentMovements from '../views/pages/ShipmentMovements/ShipmentMovements';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import ViewQuiltOutlinedIcon from '@mui/icons-material/ViewQuiltOutlined';
import { useSelector, useDispatch } from "react-redux";
import commonApiService from '../../shared/common-utilities/services/commonApiService';
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import ViewStreamOutlinedIcon from '@mui/icons-material/ViewStreamOutlined';
import Spinner from "../views/common/Spinner/Spinner";
import { fetchSavedView } from '../../../src/shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import AlertComponent from '../../shared/common-utilities/common/AlertComponent';
import ContextMenu from '../views/common/ContextMenu/ContextMenu.jsx';
import ModalComponent from '../views/common/Modal/ModalComponent.js';
// import AgendaDemo from '../views/common/Agenda/AgendaDemo.jsx';
import getSetDataService from '../../shared/common-utilities/services/getSetDataService.jsx';
import i18_en from '../../jsonStore/i18_en.json';
import WindowComponent from '../views/common/Window/WindowComponent.jsx';
import dataStorageService from '../../shared/common-utilities/services/DataStorageService.jsx';

const drawerWidth = 200;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(6)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.neutral.main,
    color: 'rgba(255, 255, 225, 0.99)',
    boxShadow: theme.shadows[10],
    fontSize: 14,
    paddingLeft: 25,
    paddingRight: 25,
  },
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const dataMainGrids = [{ index: 1, title: 'Movements', selected: false }, { index: 2, title: 'Partial Trip', selected: false }, { index: 3, title: 'Agenda', selected: false }];
const dataSubGrid = [{ index: 1, title: 'Partial Trip', parent: ['Movements'], selected: false }, { index: 2, title: 'Routes', parent: ['Movements', 'Partial Trip', 'Agenda'], selected: false }, { index: 3, title: 'Shipment Movements', parent: ['Movements', 'Partial Trip'], selected: false }, { index: 4, title: 'Scheduler', parent: ['Agenda'], selected: false }]

const tiles = [
  {
    title: 'Movements',
    defaultPosition: {
      col: 1,
      colSpan: 2,
      rowSpan: 1,
      // order: 0,
    },
    hidden: false,
    item: (
      <Movements />
      // <p>Movements Here</p>
    ),
  },
  {
    title: 'Partial Trip',
    defaultPosition: {
      col: 1,
      colSpan: 2,
      rowSpan: 1,
      // order: 1,
    },
    hidden: false,
    item: (
      <PartialTrip />
      // <p>Partial Trip Here</p>
    ),
  },
  {
    title: 'Agenda',
    defaultPosition: {
      col: 1,
      colSpan: 2,
      rowSpan: 1,
      // order: 2,
    },
    hidden: false,
    item: (
      // <AgendaDemo />
      <p>Agenda Here</p>
    ),
  },
  {
    title: 'Routes',
    defaultPosition: {
      col: 1,
      colSpan: 2,
      rowSpan: 1,
      // order: 3,
    },
    hidden: false,
    item: (
      <TripRoutes />
      // <p>Routes Here</p>
    ),
  },
  {
    title: 'Shipment Movements',
    defaultPosition: {
      col: 1,
      colSpan: 2,
      rowSpan: 1,
      // order: 4,
    },
    hidden: false,
    item: (
      <ShipmentMovements />
      // <p>Shipment Movements Here</p>
    )
  }
];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

let apiService = commonApiService();
let service = getSetDataService();
let storageService = dataStorageService();

const Sidenav = (props) => {
  const [updatedViews, setUpdatedViews] = useState([])
  const [defaultViews, setDefaultViews] = useState([]);
  const [createCustom, setCreateCustom] = useState(false)
  const [openNamePopup, setOpenNamePopup] = useState(false)
  const [gridState, setGridState] = useState({
    mainGrid: dataMainGrids,
    childGrid: dataSubGrid,
    draggedItem: {}
  })

  const [selectedTiles, setSelectedTiles] = useState([]);
  const dispatch = useDispatch();
  const updateNav = useSelector(state => state.updateSideNav);
  const updateCustomNav = useSelector(state => state.updateSideNav.customViewSelectedName);
  const navigate = useNavigate();

  const open = useSelector((state) => state.sideBar.toggleSideBar);
  const [position, setPosition] = useState();
  const [openModalCreateView, setOpenModalCreateView] = useState(false);
  const [parentGrid, setParentGrid] = useState("");
  const [subGrid, setSubGrid] = useState([]);
  const [showedSubGrid, setShowedSubGrid] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [customViewSelected, setCustomViewSelected] = useState(0);
  // const [defaultViewSelected, setDefaultViewSelected] = useState(0);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedCustomView, setSelectedCustomView] = useState();
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEditViewName, setIsEditViewName] = useState(null);
  const [customViewName, setCustomViewName] = useState('');
  const [showView, setShowView] = React.useState(false);
  const [selCustomView, setSelCustomView] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const contextMenuData = ['Rename', 'Edit View'];
  let userID = storageService.getLocalStorageData('userID');

  useEffect(() => {
    if(!localStorage.userID){
      storageService.setLocalStorageData('userID', '10000');
      userID = '10000';
    }
    fetchUpdateSavedViews(false, null);
    // getDefaultSavedViews();
  }, [])

  useEffect(() => {
    if (!_.isNil(updateNav)) {
      fetchUpdateSavedViews(false, null);
    }
  }, [updateNav])

  useEffect(() => {
    if (!_.isNil(updateCustomNav)) {
      setCustomViewSelected(updateCustomNav?.customViewSelectedName);
      setSelectedIndex(20);
    }
  }, [updateCustomNav])
  

  useEffect(() => {
    let index = 20;
    for (const data of SidebarData) {
      if (window.location.hash.includes(data.path)) {
        index = data.index;
        setCustomViewSelected(0);
        // setDefaultViewSelected(0);
        setCreateCustom(false);
      }
    }
    setSelectedIndex(index);
    if (window.location.hash.includes("#/CustomView")) {
      setCustomViewSelected(storageService.getLocalStorageData('ViewName'));
      setCreateCustom(false);
    }
  }, [window.location.hash])

  const fetchUpdateSavedViews = (isFromDeleteView, savedViewData, viewIndex) => {
    setIsLoading(true);
    const url = `${fetchSavedView}?$filter=(userID eq '${userID}' and title eq 'customView*')`;
    apiService.get(url).then(response => {
      if (savedViewData === null) {
        if (isFromDeleteView) {
          navigate('/CreateCustomView');
        }
        setUpdatedViews(response.value);
        storageService.setLocalStorageData("customView", JSON.stringify(response.value));
      } else if(response?.value?.length !== 0) {
        apiService.put(`${fetchSavedView}(${response.value[viewIndex].id})`, response.value[viewIndex]['@odata.etag'], savedViewData).then(result => {
          if (result !== undefined && result !== null) {
            if (result.error !== null && result.error !== undefined && result.error) {
              setErrorParameterAndMessage(result.error.message.split('CorrelationId')[0]);
              setOpenConfirmationModal(true);
            } else {
              const viewsData = storageService.getLocalStorageData('customView');
              let updatedViews = viewsData ? JSON.parse(viewsData) : [];
              setUpdatedViews(updatedViews);
            }
          }
        })
      }
    })
    .catch(error => {
      console.error('API error:', error);
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  // const getDefaultSavedViews = () => {
  //   setIsLoading(true);
  //   const url = `${fetchSavedView}?$filter=(title eq 'defaultCustomView*')`
  //   apiService.get(url).then(response => {
  //     if (response !== null && response !== undefined && response.value) {
  //       setDefaultViews(response.value);
  //     } else {
  //       // Error Handling code here
  //       console.error("Response value is not available.");
  //     }
  //   })
  //   .catch(error => {
  //     console.error('API error:', error);
  //   })
  //   .finally(() => {
  //     setIsLoading(false);
  //   })
  // }

  const handleListItemClick = (index, routeName) => {
    setShow(false)
    localStorage.removeItem('measurementData')
    const selectedMovementsSum = 0;
    const selectedNetWeightSum = 0;
    const selectedVolumeSum = 0;
    const selectedLLSum = 0;
    const selectedWeightSum = 0;
    let measurementField = [];
    dispatch(updateSelectedSums({ selectedNetWeightSum, selectedVolumeSum, selectedWeightSum, selectedLLSum, selectedMovementsSum, measurementField }));

    props.sideBarIndex(index);
    navigate(routeName);
    setSelectedIndex(index);
    setCustomViewSelected(0);
    // setDefaultViewSelected(0);
  };

  const handleCreateCustomViewClick = (event) => {
    setCreateCustom(true);
    setCustomViewSelected("");
    // setDefaultViewSelected(0);
    setSelectedTiles([]);
    navigate('/CreateCustomView', { state: { isEdit: false }, replace: true });
  }

  const closePopupFilter = () => {
    setOpenModalCreateView(false);
  };

  useEffect(() => {
  }, [subGrid])

  // useEffect(() => {
  //   let tempList = []
  //   tiles.map(item => showedSubGrid.filter(element => { return element.title === item.title && tempList.push(item) }))
  //   tempList.map(item => { return !selectedTiles.includes(item) && setSelectedTiles([...selectedTiles, item]) })
  // }, [showedSubGrid])

  useEffect(() => {
    let tempList = [];

    tiles.forEach(item => {
      const filteredElements = showedSubGrid.filter(element => {
        return element.title === item.title;
      });

      if (filteredElements.length > 0) {
        tempList.push(item);
      }
    });

    tempList.forEach(item => {
      if (!selectedTiles.includes(item)) {
        setSelectedTiles([...selectedTiles, item]);
      }
    });
  }, [showedSubGrid]);

  const populateChildGrid = (props, data) => {
    setParentGrid(props.dataItem.title);
    const filteredTiles = tiles.filter(item => item.title === props.dataItem.title);
    setSelectedTiles(filteredTiles); 
    let tiles = filteredTiles;
    setGridState({
      ...gridState,
      [data]: gridState[data].map((item) => {
        if (item.title === props.dataItem.title) {
          item['selected'] = true;
        } else {
          item['selected'] = false;
        }
        return item;
      })
    });
    let grid = [];
    dataSubGrid.forEach(item => {
      if (item.parent.includes(props.dataItem.title)) {
        grid.push(item);
      }
    });  
    setSubGrid(grid);
    setShowedSubGrid([]);
  }

  const displaySubView = (props) => {
    if (!showedSubGrid.includes(props.dataItem.title)) {
      const filteredItems = tiles.filter(item => item.title === props.dataItem.title);
      setShowedSubGrid([...showedSubGrid, ...filteredItems]);
    }
  }

  const openInputNamePopup = () => {
    setOpenNamePopup(true);
  }

  const handleReposition = (props) => {
    setPosition(props.value)
  }

  const customViewTabClick = (data) => {
    const viewName = service.splitTitle(data).viewName;
    storageService.setLocalStorageData("ViewName", viewName);
    navigate(`/CustomView`, { state: { data } });
    setCustomViewSelected(viewName);
    // setDefaultViewSelected(0);
    setSelectedIndex(20);
  }

  // const defaultViewTabClick = (data) => {
  //   localStorage.setItem('ViewName', splitTitle(data).viewName);
  //   navigate('/CustomView', { state: { data } })
  //   setDefaultViewSelected(splitTitle(data).viewName);
  //   setCustomViewSelected(0);
  //   setSelectedIndex(20);
  // }

  const offSet = React.useRef({
    left: 0,
    top: 0,
  });
  const [show, setShow] = React.useState(false);
  const [selectedView, setselectedView] = React.useState("");
  const onPlanButtons = (e) => {
    const href = window.location.href
    const path = href.substring(0, href.lastIndexOf("/") + 0);
    window.open(path + selectedView.path, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,height=200")
    setShow(false)
  };

  const handleContextMenu = (e, data) => {
    setShow(false)
    setShowView(false)
    setselectedView(data)
    e.nativeEvent.preventDefault();
    setTimeout(() => {
      offSet.current = {
        left: e.nativeEvent.clientX,
        top: e.nativeEvent.clientY,
      };
      setShow(true);
    }, 300);
    setTimeout(() => {
      setShow(false);
    }, 2500);
  };

  const onPlanViewButtons = (e) => {
    const viewName = service.splitTitle(updatedViews[selCustomView]).viewName;
    if (e === 'rename') {
      setIsEditViewName(selCustomView);
      setCustomViewName(viewName);
    } else if (e === 'edit-view') {
      navigate('/CreateCustomView', { state: { isEdit: true, viewName: viewName, data: updatedViews[selCustomView] }, replace: true });
      setCustomViewSelected(viewName);
      setSelectedIndex(20);
    }
    setCreateCustom(false);
    setShowView(false);
  };

  const handleViewContextMenu = (e, index) => {
    setShow(false);
    setShowView(false);
    setSelCustomView(index);
    e.nativeEvent.preventDefault();
    setTimeout(() => {
      offSet.current = {
        left: e.nativeEvent.clientX,
        top: e.nativeEvent.clientY,
      };
      setShowView(true);
    }, 300)
  };

  React.useEffect(() => {
    document.addEventListener("click", (e) => {
      if (showView) {
        e.preventDefault();
        setShowView(false);
      }
      return null;
    });
  }, [showView]);

  const deleteCustomView = (data) => {
    setDeleteDialogOpen(true);
    setSelectedCustomView(data);
  }

  const deleteCustomViewCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedCustomView();
  }

  const deleteCustomViewApiCall = () => {
    setIsLoading(true);
    const url = `${fetchSavedView}?$filter=(userID eq '${userID}' and title eq 'customView*')`
    apiService.get(url).then(response => {
      if (response !== null && response !== undefined && response.value !== null && response.value !== undefined && response.value.length > 0) {
        const deleteView = response.value.find(x=> x.id === selectedCustomView?.id);
        if (deleteView !== null && deleteView !== undefined) {
          setIsLoading(true);
          apiService.deleteData(fetchSavedView, deleteView.id, deleteView).then(result => {
            if (result === 204) {
              const isNeedToRedirect = customViewSelected === service.splitTitle(deleteView).viewName;
              fetchUpdateSavedViews(isNeedToRedirect, null);
              setSuccessSnackbarOpen(true);
              setSuccessSnackbarMessage(i18_en.operationSuccessful);
            }
            setDeleteDialogOpen(false);
          })
          .catch(error => {
            console.error('API error:', error);
          })
          .finally(() => {
            setIsLoading(false);
          })
        }
        setSelectedCustomView();
      }
    })
    .catch(error => {
      console.error('API error:', error);
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const [fullWidth, setFullWidth] = React.useState(true);

  const onChangeViewName = (e) => {
    setCustomViewName(e.target.value);
  };

  const onSaveCustomViewName = (e, index) => {
    if (e.nativeEvent.key == 'Enter' || e.nativeEvent.key == 'Tab' || e.nativeEvent.type == 'focusout') {
      let viewData = [];
      const updatedView = storageService.getLocalStorageData('customView');
      let customViews = updatedView ? JSON.parse(updatedView) : [];

      setIsEditViewName(null);
      
      if (customViewName?.trim() === "") {
        setErrorSnackbarOpen(true);
        setErrorSnackbarMessage(i18_en.selectValidViewName); 
        return null;
      }

      if (customViewName === service.splitTitle(updatedViews[index]).viewName) return;

      if (updatedViews !== null && updatedViews !== undefined && (updatedViews?.toString() ?? '') !== '') {
        viewData = updatedViews?.filter(item => {
          const parts = item?.title?.split('/');
          return parts[parts.length - 1] === customViewName;
        });
      }

      if (viewData?.length > 0) {
        setErrorSnackbarOpen(true);
        setErrorSnackbarMessage(i18_en.viewNameAlreadyExists);
        setCustomViewName(service.splitTitle(updatedViews[index]).viewName);
        return null;
      }

      const viewIndex = service.splitTitle(updatedViews[index]).index;
      const updatedTitle = `customView/${viewIndex}/${customViewName}`;
      const savedViewData = {
        "title" : updatedTitle
      };

      setIsLoading(true);
      if (customViews?.[index]?.title) {
        customViews[index].title = updatedTitle;
      }
      
      storageService.setLocalStorageData("customView", JSON.stringify(customViews));
      fetchUpdateSavedViews(false, savedViewData, index);

      if (customViewSelected === service.splitTitle(updatedViews[index]).viewName) {
        setCustomViewSelected(customViewName);
        setSelectedIndex(20);
      }
    }
  };

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setOpenConfirmationModal(true);
  }

  const closeConfirmationModal = () => {
    setOpenConfirmationModal(false);
  }

  const DeleteConfirmationComponent = (prop) => {
    if (prop?.sendDataToParent) {
      setTimeout(() => {
        prop.sendDataToParent('deletePopup');
      }, 100);
    }

    return (
      <Box sx={{ width: 350, bgcolor: "background.paper", p: 3 }} id="deletePopup">
        <Typography variant="h6" sx={{ pr: .5, justifyContent: 'center', fontSize: '15px' }}>{i18_en.deleteConfirmationMessage}{" "}<span style={{ fontWeight: "bold" }}>{service.splitTitle(selectedCustomView).viewName}</span> item?</Typography>
      </Box>
    )
  }

  const RenderActionButtons = () => {
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          onClick={deleteCustomViewCancel}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={deleteCustomViewApiCall}
        >
          Confirm
        </Button> 
      </>
    )
  }

  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)}
      <Box sx={{ display: 'flex' }} className={open ? 'active' : ''}>
        <CssBaseline />

        <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose}
        isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}
        />

        <Drawer variant="permanent" open={open}>
          <Box height={50} sx={{ minHeight: '50px' }} />

          <List component="nav" className='mainlist' >
            {SidebarData.map((data, index) => {
              return (
                <ListItem className='listingmenu' key={data.index} disablePadding sx={{ display: 'block' }} >
                  <ListItemButton onClick={() => handleListItemClick(data.index, data.path)} onContextMenu={(e) => handleContextMenu(e, data)}  sx={{ minHeight: 35, justifyContent: open ? 'initial' : 'center', py: .4, px: 1.5, }}

                    selected={selectedIndex === data.index}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                        color: 'secondary.contrastText'
                      }}
                    >
                      <LightTooltip title={data.title} placement="right">
                        <IconButton sx={{p:0}} color='#fff'>{data.icon}</IconButton>
                      </LightTooltip>
                    </ListItemIcon>
                    <ListItemText primary={data.title} className='text-wrap' primaryTypographyProps={{ fontSize: 14 }} sx={{ opacity: open ? 1 : 0, }} />
                  </ListItemButton>
                </ListItem>
              )
            })
            }

          </List>
          {/* Issue no: 185 by Gerrit-Jan */}
          {/* <List component="nav"  className='mainlist' >
            <ListItem className='listingmenu' disablePadding sx={{background: '#29477b',padding: '0px 11px'}}>
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : 'auto',
                    justifyContent: 'center',
                    color: 'secondary.contrastText',
                  }}
                >
                  <LightTooltip placement="right">
                    <AutoAwesomeMosaicOutlinedIcon />
                  </LightTooltip>
                </ListItemIcon>
                <ListItemText primary='VIEWS' className='text-wrap' primaryTypographyProps={{ fontSize: 14 }} sx={{ opacity: open ? 1 : 0, }} />            
            </ListItem>
            {defaultViews && defaultViews.map((data) => {
              return (<>
                <ListItem className='listingmenu last' disablePadding sx={{ display: 'block' }} onClick={() => defaultViewTabClick(data)}>
                  <ListItemButton sx={{ minHeight: 30, justifyContent: open ? 'initial' : 'center', px: 1.5, py: .5 }} selected={defaultViewSelected === splitTitle(data)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                        color: 'secondary.contrastText'
                      }}
                    >
                      <ViewStreamOutlinedIcon />

                    </ListItemIcon>
                    <ListItemText primary={splitTitle(data)} className='text-wrap' primaryTypographyProps={{ fontSize: 14 }} sx={{ opacity: open ? 1 : 0, }} />
                  </ListItemButton>
                </ListItem>
              </>)
            })}
          </List> */}
          <List component="nav">
            <ListItem className='listingmenu' disablePadding sx={{ display: 'block' }} >
              <ListItemButton onClick={(event) => handleCreateCustomViewClick(event)} sx={{ minHeight: 35, justifyContent: open ? 'initial' : 'center', px: 1.5, }} selected={createCustom}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : 'auto',
                    justifyContent: 'center',
                    color: 'secondary.contrastText'
                  }}
                >
                  <LightTooltip title="Custom View" placement="right">
                    <BackupTableIcon />
                  </LightTooltip>
                </ListItemIcon>
                <ListItemText primary='Custom View' className='text-wrap' primaryTypographyProps={{ fontSize: 14 }} sx={{ opacity: open ? 1 : 0, }} />
              </ListItemButton>
            </ListItem>
            {updatedViews ? updatedViews?.map((data, index) => {
              return (
                <ListItem className='listingmenu last' key={index} disablePadding sx={{ display: 'flex' }}>
                  <ListItemButton sx={{ minHeight: 30, justifyContent: open ? 'initial' : 'center', px: 1.5, py: .5, cursor: isEditViewName === index ? 'auto' : 'pointer'}} selected={customViewSelected === service.splitTitle(data).viewName} onClick={isEditViewName === index ? null : () => customViewTabClick(data)} onContextMenu={(e) => handleViewContextMenu(e, index)}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                        color: 'secondary.contrastText'
                      }}
                    >
                      <LightTooltip title={service.splitTitle(data)?.viewName} placement="right"><ViewQuiltOutlinedIcon /></LightTooltip>
                    </ListItemIcon>
                    {isEditViewName === index ? (
                      <input
                        autoFocus
                        type='text'
                        style={{ width: "90%", border:"1px solid #5cadb9", backgroundColor:"#5cadb9", minHeight:"30px", color:"#fff", outline:"none", borderRadius:"3px" }}
                        value={customViewName}
                        onChange={(e) => onChangeViewName(e)}
                        onBlur={(e) => onSaveCustomViewName(e, index)}
                        onKeyUp={(e) => onSaveCustomViewName(e, index)}
                      />
                    ) : (
                      <ListItemText primary={service.splitTitle(data).viewName} className='text-wrap' primaryTypographyProps={{ fontSize: 14 }} sx={{ opacity: 1 }} />
                    )}
                  </ListItemButton>
                  {(open && (isEditViewName === null || isEditViewName !== index)) &&
                    <IconButton edge="end" sx={{ mr: .2 }} aria-label="delete" size="small" color='danger' onClick={() => deleteCustomView(data)}><CloseIcon /></IconButton>
                  }
                </ListItem>
              )
            })
          : null }
          </List>
        </Drawer>

        {/* Context menu for SideBar Main List */}
        {show ? <ContextMenu flag="sideBar" offset={offSet.current} data={['Open in new window']} sendToParent={onPlanButtons} /> : null}

         {/* Context menu for Custom View List */}
        {showView ? <ContextMenu flag="customView" offset={offSet.current} data={contextMenuData} sendToParent={onPlanViewButtons} /> : null}

      </Box>

      <BootstrapDialog open={openModalCreateView} onClose={closePopupFilter} fullScreen={fullScreen} fullWidth={fullWidth} maxWidth={'lg'}>
        <DialogTitle className='headBG' sx={{ color: 'secondary.contrastText' }}>
          Create Custom View
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={closePopupFilter}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[100],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Card sx={{ boxShadow: 0, p: 0 }}>
            {/* <CardHeader title="Create Custom View" sx={{ py: 1, px: 3, color: 'primary.main' }} titleTypographyProps={{ variant: 'subtitle1', fontWeight: 700 }} />
          <Divider /> */}
            <CardContent sx={{ padding: 1, overflowY: 'auto' }}>
              <Stack direction="row" spacing={1} >
                {/* spacing={1} > */}
                <Grid style={{ display: 'block' }}>
                  <Box sx={{ width: 150, height: 'auto', mb: 3 }}>
                    <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Available Main Grids</Typography>
                    <ListBox style={{ height: 300, width: '100%' }}
                      data={dataMainGrids}
                      textField="title"
                      selectedField='selected'
                      onItemClick={(e) => populateChildGrid(e, "mainGrid")}
                    />
                  </Box>
                  <Box sx={{ width: 150, height: 'auto' }}>
                    <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Available Sub Grids</Typography>
                    <ListBox style={{ height: 280, width: '100%' }}
                      data={subGrid}
                      textField="title"
                      selectedField='selected'
                      onItemClick={displaySubView}
                    // onDragStart={draggingSubGrid}
                    />
                  </Box>
                </Grid>
                <Grid sx={{ width: "100%", height: '500px' }} >
                  <TileLayout
                    columns={2}
                    rowHeight={300}
                    gap={{
                      rows: 10,
                      columns: 10,
                    }}
                    items={selectedTiles}
                    // items={customViewTiles.filter(item => item.hidden !== true)}
                    onReposition={handleReposition}

                  />
                  {/* <TileLayoutComponent tiles={tiles} selectedTile={selectedTile} /> */}

                </Grid>
              </Stack>
              {/* <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 2, pt: 2 }}>
              <Button variant="outlined" size="small" disabled={parentGrid.length == 0 ? true : false}
                // onClick={saveCustomView}>
                onClick={openInputNamePopup}>
                Save
              </Button>
            </Stack> */}
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="contained" disabled={parentGrid.length == 0 ? true : false}
            // onClick={saveCustomView}>
            onClick={openInputNamePopup}>
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
      
      {/* open delete confirmation modal for custom view  */}
      {isDeleteDialogOpen && <WindowComponent title={"Delete Confirmation"} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={210} minWidth={400} minHeight={210} onClose={deleteCustomViewCancel} dataComponent={DeleteConfirmationComponent} actionButtons={<RenderActionButtons />} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}

      <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
    </>
  );
}


export default Sidenav;
